import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import {
  QuoteApproverRequest,
  QuoteApproverResponse,
  QuoteApproverSignatureRequest
} from '../models/quote-approver.model';

/**
 * API de Responsables de aprobación de cotizaciones (RF-001 — /api/quote-approvers).
 * Usuarios autorizados para aprobar cotizaciones, con firma registrada.
 */
@Injectable({
  providedIn: 'root'
})
export class QuoteApproverApiService {
  private readonly apiUrl = `${environment.apiUrl}api/quote-approvers`;

  constructor(private http: HttpClient) { }

  // GET /api/quote-approvers — lista de responsables (selector). Rol Sales Rep+.
  // includeInactive default false.
  getApprovers(businessId: number, includeInactive?: boolean): Observable<QuoteApproverResponse[]> {
    let params = new HttpParams().set('businessId', businessId.toString());
    if (includeInactive !== undefined) {
      params = params.set('includeInactive', includeInactive ? 'true' : 'false');
    }
    return this.http.get<QuoteApproverResponse[]>(this.apiUrl, { params })
      .pipe(map(r => r ?? []));
  }

  // GET /api/quote-approvers/{id}
  getApproverById(id: number, businessId: number): Observable<QuoteApproverResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<QuoteApproverResponse>(`${this.apiUrl}/${id}`, { params });
  }

  // POST /api/quote-approvers — Rol Manager+.
  // Errores: 409 usuario ya es responsable activo; 422 usuario no activo del negocio.
  createApprover(businessId: number, request: QuoteApproverRequest): Observable<QuoteApproverResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.post<QuoteApproverResponse>(this.apiUrl, request, { params });
  }

  // PUT /api/quote-approvers/{id} — Rol Manager+.
  updateApprover(id: number, businessId: number, request: QuoteApproverRequest): Observable<QuoteApproverResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.put<QuoteApproverResponse>(`${this.apiUrl}/${id}`, request, { params });
  }

  // PUT /api/quote-approvers/{id}/signature — actualiza solo la firma registrada. Rol Manager+.
  updateSignature(id: number, businessId: number, request: QuoteApproverSignatureRequest): Observable<QuoteApproverResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.put<QuoteApproverResponse>(`${this.apiUrl}/${id}/signature`, request, { params });
  }

  // DELETE /api/quote-approvers/{id} — Rol Manager+.
  deleteApprover(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.apiUrl}/${id}`, { params });
  }
}
